import { CarrierVerification } from 'types/CarrierVerification';
import { CarrierVerification as CarrierVerificationEnum } from 'types/enums/Integrations';

// Build the external "View Profile" URL for a carrier verification result.
export function getCarrierVerificationProfileUrl(
  carrier: Pick<
    CarrierVerification,
    'integration_name' | 'dot_number' | 'docket_number' | 'carrier_id'
  >
): string {
  switch (carrier.integration_name) {
    case CarrierVerificationEnum.MyCarrierPortal:
      return `https://mycarrierpackets.com/CarrierInformation/DOTNumber/${carrier.dot_number}/DocketNumber/${carrier.docket_number}`;
    case CarrierVerificationEnum.Highway:
      return carrier.carrier_id
        ? `https://highway.com/broker/carriers/${carrier.carrier_id}`
        : '';
    case CarrierVerificationEnum.FreightValidate:
      return `https://freightvalidate.com/carrier/${carrier.dot_number}`;
    case CarrierVerificationEnum.Truckstop:
      return `https://truckstop.com/carrier/${carrier.dot_number}`;
    default:
      return '';
  }
}
